import type { LanguageModelUsage } from "ai";

type LastTurnUsage = {
	promptTokens: number;
	cachedInputTokens: number;
	completionTokens: number;
	reasoningTokens: number;
	model: string;
};

export function buildContextMeterUsage(lastTurn: LastTurnUsage): {
	usedTokens: number;
	usage: LanguageModelUsage;
} {
	const cachedInputTokens = Math.min(
		lastTurn.cachedInputTokens,
		lastTurn.promptTokens,
	);
	const reasoningTokens = Math.min(
		lastTurn.reasoningTokens,
		lastTurn.completionTokens,
	);
	const usedTokens = lastTurn.promptTokens + lastTurn.completionTokens;
	return {
		usedTokens,
		usage: {
			inputTokens: lastTurn.promptTokens,
			inputTokenDetails: {
				noCacheTokens: lastTurn.promptTokens - cachedInputTokens,
				cacheReadTokens: cachedInputTokens,
				cacheWriteTokens: undefined,
			},
			outputTokens: lastTurn.completionTokens,
			outputTokenDetails: {
				textTokens: lastTurn.completionTokens - reasoningTokens,
				reasoningTokens,
			},
			reasoningTokens,
			cachedInputTokens,
			totalTokens: usedTokens,
		},
	};
}
